import { useEffect } from "react";
import UsagePolicies from "../../Components/UsagePolicies";

const MastersPolpaico = () => {
  useEffect(() => {
    document.title = "Maestros Polpaico";

    return () => {
      document.title = "Politicas de uso";
    };
  }, []);
  return (
    <UsagePolicies
      proyect="Maestro Polpaico"
      policies={[
        {
          title: "",
          description:
            "Maestro Polpaico es un proyecto dedicado para gestionar a los colaboradores de Polpaico",
        },
        {
          title: "Recopilación y uso de datos personales",
          description: `
            * Esta aplicación no recupera datos personales.
            `,
        },
        {
          title: "Privacidad de menores",
          description: `
          * Esta aplicación no está dirigida a ninguna persona inferior a los 13 años de edad. No se recopila información personal de niños en esta aplicación.
            `,
        },
      ]}
    />
  );
};

export default MastersPolpaico;
